import { ComponentRoute } from '@/classes'

const UtilitiesRoutes = {
  OrmUtilitiesView: new ComponentRoute('/utilities/orm/:quoteId?', 'OrmUtilitiesView'),
  OrmUtilitiesDetail: new ComponentRoute('/utilities/orm/:quoteId?', 'OrmUtilitiesDetail'),
  PnetUtilitiesView: new ComponentRoute('/utilities/pnet/:quoteId?', 'PnetUtilitiesView'),
  PnetUtilitiesDetail: new ComponentRoute('/utilities/pnet/:quoteId?', 'PnetUtilitiesDetail')
}

export default UtilitiesRoutes